import React, { useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { lineCalculations, formatNumber, roundNumber } from '../../helpers'

const PriceCoefficient = ({qline, index, calculations, replaceLine, useRevient, overheadMult}) => {
  // Coef base = purchase price (legacy) or Coût de revient (= PA × (1 + Coef. FG)) when
  // the cost-breakdown preference is on and the line has a category.
  const displayedCoef = useRevient ? calculations.coefficientCostPrice : calculations.coefficientPrice
  const [active, setActive] = useState(false);
  const [coefficient, setCoefficient] = useState(displayedCoef);

  const activateInput = () => {
    setCoefficient(roundNumber(displayedCoef))
    setActive(true)
  }

  const onChange = (e) => {
    const coefficient = parseFloat(e.target.value) || ""
    setCoefficient(coefficient)
  }

  const onCancel = () => {
    setActive(false)
    setCoefficient(displayedCoef)
  }

  const recalculateSalesPrice = () => {
    if (typeof(coefficient) != 'number') return

    const base = useRevient
      ? (parseFloat(qline.purchase_price) || 0) * overheadMult
      : (parseFloat(qline.purchase_price) || 0)
    const new_price = roundNumber(base * coefficient)
    replaceLine({...qline, unit_price: new_price}, index)
    setActive(false)
  }

  return(
    <>
      {
        active
        ? <div className="calculation details">
            <div className="text-cut">{I18n.t("quotes.bigcard.coefficient")}</div>
            <div style={{width: '60px'}}>
              {/* Price coefficient input */}
              <input
                type="number"
                min="0"
                step="0.1"
                className="form-control"
                value={coefficient || ""}
                onChange={onChange}
              />

              <div className="action-buttons">
                {/* Cancel */}
                <div tooltip={I18n.t("button.cancel")}
                     onClick={onCancel}
                >
                  <FontAwesomeIcon
                    className="check-circle"
                    icon="times-circle"
                  />
                </div>

                {/* Apply */}
                <div tooltip={I18n.t("button.apply")}
                     onClick={recalculateSalesPrice}
                >
                  <FontAwesomeIcon
                    className="check-circle"
                    icon="check-circle"
                  />
                </div>
              </div>
            </div>
          </div>
        : <div className="calculation details coefficient" onClick={activateInput}>
            <div>{I18n.t("quotes.bigcard.coefficient")}</div>
            <div>{formatNumber(calculations.coefficientPrice)}</div>
          </div>
      }
    </>
  )
}

export default class Calculations extends React.Component {
  render() {
    const { qline, index, replaceLine, showMargin, showPriceCoefficient, useRevient, overheadCoef } = this.props
    const overheadMult = 1 + (parseFloat(overheadCoef) || 0)
    const calculations = lineCalculations(this.props.qline, overheadMult)
    const showRevient  = !!useRevient && !!showMargin

    return(
      <div className="calculations">
        <div className="calculation">
          <div>Total</div>
          <div>{formatNumber(calculations.total)} {qline.currency_symbol}</div>
        </div>

        {
          showMargin &&
          <React.Fragment>
            <div className="calculation details">
              <div className="text-cut">
                {I18n.t("quotes.bigcard.purchase")}
              </div>
              <div>{formatNumber(calculations.purchase)} {qline.currency_symbol}</div>
            </div>

            { showRevient &&
              <div className="calculation details">
                <div className="text-cut">
                  {I18n.t("quotes.bigcard.cost_price")}
                </div>
                <div>{formatNumber(calculations.costPrice)} {qline.currency_symbol}</div>
              </div>
            }

            <div className="calculation details">
              <div className="text-cut">
                {I18n.t("quotes.bigcard.margin")}
              </div>
              <div>{formatNumber(calculations.margin)} %</div>
            </div>

            {/* Coefficient price */}
            { showPriceCoefficient
              ? <PriceCoefficient
                  qline={qline}
                  index={index}
                  calculations={calculations}
                  replaceLine={replaceLine}
                  useRevient={showRevient}
                  overheadMult={overheadMult}
                />
              : <div className="calculation details">
                  <div className="text-cut">
                    {I18n.t("quotes.bigcard.coefficient")}
                  </div>
                  <div>{formatNumber(showRevient ? calculations.coefficientOnCostPrice : calculations.coefficient)}</div>
                </div>
            }

          </React.Fragment>
        }

      </div>
    )
  }
}
